/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Count } from '../models/count';
import { Id } from '../models/id';
import { Order } from '../models/order';
import { Product } from '../models/product';


/**
 * Api open to all clients
 */
@Injectable({
  providedIn: 'root',
})
export class ClientService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProducts
   */
  static readonly GetProductsPath = '/products';

  /**
   * Get all products.
   *
   * Retrieve all products
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts$Response(params?: {

    /**
     * Product id
     */
    product_id?: number;

    /**
     * Product description
     */
    description?: string;

    /**
     * Price lower bound
     */
    priceFrom?: number;

    /**
     * Price upper bound
     */
    priceTo?: number;

    /**
     * Quantity lower bound
     */
    quantityFrom?: number;

    /**
     * Quantity upper bound
     */
    quantityTo?: number;

    /**
     * Product country of origin
     */
    origin?: string;

    /**
     * Category id
     */
    category?: number;

    /**
     * Warehouse id
     */
    warehouse_id?: number;

    /**
     * List offset for pagination
     */
    offset?: number;

    /**
     * Limit the number of retrieved products
     */
    limit?: number;

    /**
     * Sorting option
     */
    sort?: 'modified_at' | 'price' | 'created_at';

    /**
     * Order for sorting
     */
    order?: 'asc' | 'desc';
  }): Observable<StrictHttpResponse<Array<Product>>> {

    const rb = new RequestBuilder(this.rootUrl, ClientService.GetProductsPath, 'get');
    if (params) {
      rb.query('product_id', params.product_id, {});
      rb.query('description', params.description, {});
      rb.query('priceFrom', params.priceFrom, {});
      rb.query('priceTo', params.priceTo, {});
      rb.query('quantityFrom', params.quantityFrom, {});
      rb.query('quantityTo', params.quantityTo, {});
      rb.query('origin', params.origin, {});
      rb.query('category', params.category, {});
      rb.query('warehouse_id', params.warehouse_id, {});
      rb.query('offset', params.offset, {});
      rb.query('limit', params.limit, {});
      rb.query('sort', params.sort, {});
      rb.query('order', params.order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Product>>;
      })
    );
  }

  /**
   * Get all products.
   *
   * Retrieve all products
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts(params?: {

    /**
     * Product id
     */
    product_id?: number;

    /**
     * Product description
     */
    description?: string;

    /**
     * Price lower bound
     */
    priceFrom?: number;

    /**
     * Price upper bound
     */
    priceTo?: number;

    /**
     * Quantity lower bound
     */
    quantityFrom?: number;

    /**
     * Quantity upper bound
     */
    quantityTo?: number;

    /**
     * Product country of origin
     */
    origin?: string;

    /**
     * Category id
     */
    category?: number;

    /**
     * Warehouse id
     */
    warehouse_id?: number;

    /**
     * List offset for pagination
     */
    offset?: number;

    /**
     * Limit the number of retrieved products
     */
    limit?: number;

    /**
     * Sorting option
     */
    sort?: 'modified_at' | 'price' | 'created_at';

    /**
     * Order for sorting
     */
    order?: 'asc' | 'desc';
  }): Observable<Array<Product>> {

    return this.getProducts$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Product>>) => r.body as Array<Product>)
    );
  }

  /**
   * Path part for operation countProducts
   */
  static readonly CountProductsPath = '/count/products';

  /**
   * Get count products.
   *
   * Retrieve count products
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  countProducts$Response(params?: {

    /**
     * Product id
     */
    product_id?: number;

    /**
     * Product description
     */
    description?: string;

    /**
     * Price lower bound
     */
    priceFrom?: number;

    /**
     * Price upper bound
     */
    priceTo?: number;

    /**
     * Quantity lower bound
     */
    quantityFrom?: number;

    /**
     * Quantity upper bound
     */
    quantityTo?: number;

    /**
     * Product country of origin
     */
    origin?: string;

    /**
     * Category id
     */
    category?: number;

    /**
     * Warehouse id
     */
    warehouse_id?: number;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, ClientService.CountProductsPath, 'get');
    if (params) {
      rb.query('product_id', params.product_id, {});
      rb.query('description', params.description, {});
      rb.query('priceFrom', params.priceFrom, {});
      rb.query('priceTo', params.priceTo, {});
      rb.query('quantityFrom', params.quantityFrom, {});
      rb.query('quantityTo', params.quantityTo, {});
      rb.query('origin', params.origin, {});
      rb.query('category', params.category, {});
      rb.query('warehouse_id', params.warehouse_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * Get count products.
   *
   * Retrieve count products
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `countProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countProducts(params?: {

    /**
     * Product id
     */
    product_id?: number;

    /**
     * Product description
     */
    description?: string;

    /**
     * Price lower bound
     */
    priceFrom?: number;

    /**
     * Price upper bound
     */
    priceTo?: number;

    /**
     * Quantity lower bound
     */
    quantityFrom?: number;

    /**
     * Quantity upper bound
     */
    quantityTo?: number;

    /**
     * Product country of origin
     */
    origin?: string;

    /**
     * Category id
     */
    category?: number;

    /**
     * Warehouse id
     */
    warehouse_id?: number;
  }): Observable<Count> {

    return this.countProducts$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation getProduct
   */
  static readonly GetProductPath = '/product';

  /**
   * Get product by product_id.
   *
   * Retrieve a product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProduct$Response(params: {

    /**
     * product id
     */
    product_id: number;
  }): Observable<StrictHttpResponse<Product>> {

    const rb = new RequestBuilder(this.rootUrl, ClientService.GetProductPath, 'get');
    if (params) {
      rb.query('product_id', params.product_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Product>;
      })
    );
  }

  /**
   * Get product by product_id.
   *
   * Retrieve a product
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProduct(params: {

    /**
     * product id
     */
    product_id: number;
  }): Observable<Product> {

    return this.getProduct$Response(params).pipe(
      map((r: StrictHttpResponse<Product>) => r.body as Product)
    );
  }

  /**
   * Path part for operation getOrigins
   */
  static readonly GetOriginsPath = '/origins';

  /**
   * Get all origins.
   *
   * Retrieve all origins
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrigins()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrigins$Response(params?: {

    /**
     * Minimum number of product for each category
     */
    minQuantity?: number;
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ClientService.GetOriginsPath, 'get');
    if (params) {
      rb.query('minQuantity', params.minQuantity, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * Get all origins.
   *
   * Retrieve all origins
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOrigins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrigins(params?: {

    /**
     * Minimum number of product for each category
     */
    minQuantity?: number;
  }): Observable<Array<string>> {

    return this.getOrigins$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation placeOrder
   */
  static readonly PlaceOrderPath = '/order';

  /**
   * Place a new order.
   *
   * Place a new order in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeOrder$Response(params: {
    body: Order
  }): Observable<StrictHttpResponse<Id>> {

    const rb = new RequestBuilder(this.rootUrl, ClientService.PlaceOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Id>;
      })
    );
  }

  /**
   * Place a new order.
   *
   * Place a new order in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `placeOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeOrder(params: {
    body: Order
  }): Observable<Id> {

    return this.placeOrder$Response(params).pipe(
      map((r: StrictHttpResponse<Id>) => r.body as Id)
    );
  }

}
